import { AppConfig } from "@/config/index";

export const statjsCode = `
<!--  ClickCease Tracking-->
<script type='text/javascript'>
    var script = document.createElement('script');
    script.async = true; script.type = 'text/javascript';
    var target = '${AppConfig.siteUrl}/monitor/stat.js';
    script.src = target;var elem = document.head;elem.appendChild(script);
</script>
<noscript>
    <a href='${AppConfig.siteUrl}' rel='nofollow'><img src='${AppConfig.siteUrl}/stats/stats.aspx' alt='ClickCease'/></a>
</noscript>
<!--  ClickCease Tracking-->
`;
